import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UbicacionesService } from 'src/app/service/ubicaciones.service';

declare let L: any;

@Component({
  selector: 'app-consultorios-especialidades',
  templateUrl: './consultorios-especialidades.component.html',
  styleUrls: ['./consultorios-especialidades.component.css']
})
export class ConsultoriosEspecialidadesComponent implements OnInit {
  private subscription = new Subscription();
    dont:any ;
    estados: any[] = [];
    estadoSeleccionado: any = null;
    dataesp: any = {};
    espec: boolean = false;
    map: any;
    icon: any;
    icons: any;
    markerarr: any[] = [];
    theMarker: any;

    geopotitonok = false;
    isLocated = false;
    zoom = 5;
    lat = 23.6345;
    lng = -102.5528;

  constructor(
    private _ubicacionesService: UbicacionesService,
    private router: Router
  ) {
    this.router.events
          .pipe(filter((event: any) => event instanceof NavigationEnd))
          .subscribe();
   }
    @HostListener('window:resize', ['$event'])
     onResize(event?: Event) {
       if (this.map) {
        this.map.invalidateSize();
      }
     }

     ngOnInit(): void {
       this.getEstados();
     }

     ngAfterViewInit(): void {
      setTimeout(() => {
        this.initMap();
        }, 100);
      }

     initMap() {
       this.icon = L.icon({
         iconUrl: 'assets/images/location_psicho.png',
         iconSize: [40, 40],
         iconAnchor: [16, 38],
         popupAnchor: [3, -50]
       });

       this.icons = L.icon({
         iconUrl: 'assets/images/location_usuario.png',
         iconSize: [40, 40],
         iconAnchor: [16, 38],
         popupAnchor: [3, -50]
       });

       this.map = L.map('mapnu').setView([this.lat, this.lng], this.zoom);

       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
         attribution:
           '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
       }).addTo(this.map);

       this.setUserLocation();
     }

     setUserLocation() {
  // Evitamos usar navigator.geolocation
  if (!this.isLocated) {
    this.isLocated = true;

    // Usamos las coordenadas de la sucursal seleccionada (dataesp)
    if (this.dataesp && this.dataesp.latitud && this.dataesp.longitud) {
      this.lat = this.dataesp.latitud;
      this.lng = this.dataesp.longitud;

      // Dibuja un círculo en la ubicación de la sucursal
      L.circle([this.lat, this.lng], {
        color: '#82b1ff',
        fillColor: '#90caf9',
        fillOpacity: 0.4,
        radius: 900
      }).addTo(this.map);

      // Agrega el marcador de la sucursal
      this.theMarker = L.marker([this.lat, this.lng], { icon: this.icons }).addTo(this.map);

      // Centra el mapa en la sucursal
      this.map.flyTo([this.lat, this.lng], 14);
    } else {
      console.warn('⚠️ dataesp no tiene coordenadas o aún no está definida.');
    }
  }
}
     getEstados() {
       this.subscription.add(
         this._ubicacionesService.getEstadosEspecialidades().subscribe((resp: any) => {
           console.log('Estados recibidos:', resp);
           this.estados = resp;
           
         })
       );
     }

     onEstadoChange() {
       console.log('Estado seleccionado:', this.estadoSeleccionado);

       if (!this.estadoSeleccionado?.sucursales?.length) {
         console.warn('Estado sin sucursales válidas');
         this.dont = true;
         this.espec = false;
         return;
       }

       this.geopotitonok = true;
       this.clearMapMarkers();

       // Tomar la primera sucursal como ejemplo
       const [first] = this.estadoSeleccionado.sucursales;

       if (first) {
         this.dataesp = first; // Asigna la sucursal al objeto que se mostrará
         this.espec = true;
         this.dont = false;
         this.map.setView([first.latitud, first.longitud], 9);
       }

       // Pintar marcadores
       this.estadoSeleccionado.sucursales.forEach((sucursal: any) => {
         if (!sucursal.latitud || !sucursal.longitud) return;

         const marker = L.marker([sucursal.latitud, sucursal.longitud], { icon: this.icon })
           .addTo(this.map)
           .bindPopup(`
             <b>${sucursal.unidad}</b><br>
             Calle: ${sucursal.calle}<br>
             No. Ext: ${sucursal.numeroExterior || 'S/N'}<br>
             Colonia: ${sucursal.colonia}<br>
             C.P.: ${sucursal.codigoPostal}<br>
             Teléfono: ${sucursal.telefono}
           `);

         this.markerarr.push(marker);
       });
     }

     clearMapMarkers() {
       this.markerarr.forEach((m) => this.map.removeLayer(m));
       this.markerarr = [];
     }

}
